import { Image, Microscope, Lightbulb, FileText, LucideIcon } from "lucide-react";

export interface ContentTypeConfig {
  icon: LucideIcon;
  variant: 'blue' | 'green' | 'purple' | 'orange' | 'gray';
  label: string;
  badgeBg: string;
  badgeHover: string;
}

export const getContentTypeConfig = (contentType: string): ContentTypeConfig => {
  switch (contentType) {
    case 'image':
      return { 
        icon: Image, 
        variant: 'blue' as const, 
        label: 'Image',
        badgeBg: 'bg-blue-600/90',
        badgeHover: 'group-hover:bg-blue-500/90'
      };
    case 'research':
      return { 
        icon: Microscope, 
        variant: 'green' as const, 
        label: 'Research',
        badgeBg: 'bg-green-600/90',
        badgeHover: 'group-hover:bg-green-500/90'
      };
    case 'private_research':
      return { 
        icon: Microscope, 
        variant: 'green' as const, 
        label: 'Research',
        badgeBg: 'bg-green-600/90',
        badgeHover: 'group-hover:bg-green-500/90'
      };
    case 'private_image':
      return { 
        icon: Image, 
        variant: 'blue' as const, 
        label: 'Image',
        badgeBg: 'bg-blue-600/90',
        badgeHover: 'group-hover:bg-blue-500/90'
      };
    case 'private_page':
      return { 
        icon: FileText, 
        variant: 'purple' as const, 
        label: 'Document',
        badgeBg: 'bg-purple-600/90',
        badgeHover: 'group-hover:bg-purple-500/90'
      };
    // 🎯 NEW CONTENT TYPE CASES CAN BE ADDED HERE
    // Example:
    // case 'new_type':
    //   return { 
    //     icon: NewIcon, 
    //     variant: 'purple' as const, 
    //     label: 'New Content',
    //     badgeBg: 'bg-purple-600/90',
    //     badgeHover: 'group-hover:bg-purple-500/90'
    //   };
    case 'app_idea':
      return { 
        icon: Lightbulb, 
        variant: 'orange' as const, 
        label: 'App Idea',
        badgeBg: 'bg-orange-600/90',
        badgeHover: 'group-hover:bg-orange-500/90'
      };
    default:
      return { 
        icon: Microscope, 
        variant: 'gray' as const, 
        label: contentType,
        badgeBg: 'bg-gray-600/90',
        badgeHover: 'group-hover:bg-gray-500/90'
      };
  }
}; 